import { SportId } from '@collector/sportsapi-client-legacy'
import router from '@mobile/router'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

import { SoccerRelationIoCBindings } from '../../Sports/Soccer/SoccerRelationDependencies/SoccerRelationDependencies'
import { RelationIoCBindings } from '../RelationDependencies/types'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useSportConfiguration() {
  const ioc = router.currentRoute.value.meta.ioc
  if (!ioc) {
    throw Error(
      'IoC Container has to be instantiated and injected into route meta before using sport configuration',
    )
  }

  const probableEvent = ioc.get(RelationIoCBindings.ProbableEvent)

  const eventStatusesConfiguration = ioc.get(
    RelationSportCommonIoCBindings.EventStatusesConfiguration,
  )
  const incidentHandlersConfiguration = ioc.get(
    RelationSportCommonIoCBindings.IncidentHandlersConfiguration,
  )
  const incidentsConfiguration = ioc.get(
    RelationSportCommonIoCBindings.IncidentsConfiguration,
  )
  const incidentsResultConfiguration = ioc.get(
    RelationSportCommonIoCBindings.IncidentsResultConfiguration,
  )
  const eventStatusesList = ioc.get(
    RelationSportCommonIoCBindings.EventStatusesList,
  )
  const lineupsConfiguration = ioc.get(
    RelationSportCommonIoCBindings.LineupsConfiguration,
  )
  const assignableIncidentsConfiguration = ioc.get(
    RelationSportCommonIoCBindings.AssignableIncidentsConfiguration,
  )
  const hooks = ioc.get(RelationSportCommonIoCBindings.EventNotificationHooks)
  const eventHeaderConfiguration = ioc.get(
    RelationSportCommonIoCBindings.EventHeaderConfiguration,
  )
  const eventClockConfiguration = ioc.get(
    RelationSportCommonIoCBindings.EventClockConfiguration,
  )
  // remove this sport check when will be more supported sports
  const disabledIncidentsWithSameTime =
    probableEvent.value.sport_id === SportId.Soccer
      ? ioc.get(SoccerRelationIoCBindings.DisabledIncidentsWithSameTime)
      : []

  // remove this sport check when will be more supported sports
  const enabledIncidentSequencesWithSameTime =
    probableEvent.value.sport_id === SportId.Soccer
      ? ioc.get(SoccerRelationIoCBindings.EnabledIncidentSequencesWithSameTime)
      : []

  return {
    eventStatusesConfiguration,
    incidentHandlersConfiguration,
    incidentsConfiguration,
    incidentsResultConfiguration,
    eventStatusesList,
    lineupsConfiguration,
    assignableIncidentsConfiguration,
    hooks,
    eventHeaderConfiguration,
    eventClockConfiguration,
    disabledIncidentsWithSameTime,
    enabledIncidentSequencesWithSameTime,
  }
}
